// extracted by css-extract-rspack-plugin
export default {"TabList":"P7IOJ"};